const updateOrders = ($listEl, ordersHtml) => {
  if (typeof ordersHtml === "string") {
    $listEl.innerHTML = ordersHtml;
  }
};

const updateEmptyState = ({ ordersCount, $emptyStateEl, $listEl, $paginationEl }) => {
  if (typeof ordersCount !== "number") return;
  const hasOrders = ordersCount > 0;
  if ($emptyStateEl) {
    $emptyStateEl.classList.toggle("hidden", hasOrders);
  }
  if ($listEl) {
    $listEl.classList.toggle("hidden", !hasOrders);
  }
  if ($paginationEl) {
    $paginationEl.classList.toggle("hidden", !hasOrders);
  }
};

export { updateOrders, updateEmptyState };
